import { type MessageId } from "@cmmd-forge/contracts";
import { useCallback, useRef } from "react";

export function useTimelineRevertControls(input: {
  readonly revertTurnCountByUserMessageId: ReadonlyMap<MessageId, number>;
  readonly onRevertToTurnCount: (targetTurnCount: number) => void | Promise<void>;
}) {
  const revertTurnCountRef = useRef(input.revertTurnCountByUserMessageId);
  revertTurnCountRef.current = input.revertTurnCountByUserMessageId;
  const onRevertToTurnCountRef = useRef(input.onRevertToTurnCount);
  onRevertToTurnCountRef.current = input.onRevertToTurnCount;

  return useCallback((messageId: MessageId) => {
    const targetTurnCount = revertTurnCountRef.current.get(messageId);
    if (typeof targetTurnCount !== "number") {
      return;
    }
    void onRevertToTurnCountRef.current(targetTurnCount);
  }, []);
}
